// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"31d12d64","697":"7387440b","702":"9638f34f"}[chunkId] + ".chunk.js";
};